<template>
  <div>
    <div class="w-full flex mb-4">
      <report-date-picker v-model="dateRange" @change="getReports"/>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 grid-cols-3 gap-4">
      <stats-card
        :loading="loading"
        class="col-span-1"
        :small-title="$t('reports.mostActiveClient')"
        type="success"
        icon="nc-icon nc-spaceship">
        <template v-slot:title>
          {{ getMaxFor('jobsPerClientTotals').client_name }}
          <span class="text-base font-medium">{{ getMaxFor('jobsPerClientTotals').total }} jobs</span>
        </template>
      </stats-card>

      <stats-card
        :loading="loading"
        :title="jobsPerClientTotals.results.length"
        :previous-title="previousJobsPerClientTotals.results.length"
        class="col-span-1"
        :small-title="'Total clients with posted jobs'"
        type="warning"
        icon="nc-icon nc-circle-10">
      </stats-card>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <jobs-per-client-report :date-from="dateFrom"
                              :date-till="dateTill"
                              :all-job-boards="true"
      />
    </div>
    <registered-clients-report :date-from="dateFrom" :date-till="dateTill"/>
  </div>
</template>
<script>
import get from 'lodash/get'
import parseISO from 'date-fns/parseISO'
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays'
import subDays from 'date-fns/subDays'
import format from 'date-fns/format'
import ReportDatePicker from './ReportDatePicker'
import BarChart from 'src/components/Charts/BarChart'
import StatsCard from '@/components/Cards/StatsCard'
import ReportService from '@/services/ReportService'
import JobsPerClientReport from '@/views/admin/reports/JobsPerClientReport'
import RegisteredClientsReport from '@/views/admin/reports/RegisteredClientsReport'
import { getDefaultRange } from '@/views/admin/reports/defaultReportRange'

export default {
  components: {
    BarChart,
    StatsCard,
    ReportDatePicker,
    JobsPerClientReport,
    RegisteredClientsReport
  },
  data () {
    const year = new Date().getFullYear()
    const defaultRange = getDefaultRange()
    return {
      year,
      defaultRange,
      dateRange: [...defaultRange],
      creditTotals: {
        results: []
      },
      creditsToExpire: {
        results: []
      },
      previousJobsPerClientTotals: {
        results: []
      },
      jobsPerClientTotals: {
        results: []
      },
      loading: false,
    }
  },
  computed: {
    dateFrom () {
      return get(this.dateRange, '[0]', this.defaultRange[0])
    },
    dateTill () {
      return get(this.dateRange, '[1]', this.defaultRange[1])
    },
    previousDateFrom () {
      const from = parseISO(this.dateFrom)
      const till = parseISO(this.dateTill)
      const difference = differenceInCalendarDays(till, from)
      return format(subDays(from, difference), 'yyyy-MM-dd')
    },
    previousDateTill () {
      return this.dateFrom
    },
    previousJobsPerClientReport () {
      return {
        model: 'jobs',
        group: 'clients',
        select: 'id,total,client',
        date_range: 'custom',
        date_from: this.previousDateFrom,
        date_till: this.previousDateTill,
        sort: 'date_month',
      }
    },
    jobsPerClientReport () {
      return {
        model: 'jobs',
        group: 'clients',
        select: 'id,total,client',
        date_range: 'custom',
        date_from: this.dateFrom,
        date_till: this.dateTill,
        sort: 'date_month',
      }
    },
  },
  methods: {
    getMaxFor (dataType) {
      let maxItem = {total: 0}
      this[dataType].results.forEach(item => {
        if (item.total > maxItem.total) {
          maxItem = item
        }
      })
      return maxItem
    },
    async getReports () {
      try {
        this.loading = true
        await Promise.all([
          this.getJobsPerClientReports(),
          this.getPreviousJobsPerClientReports()
        ])
      } finally {
        this.loading = false
      }
    },
    async getJobsPerClientReports () {
      const {data} = await ReportService.get(this.jobsPerClientReport)
      this.jobsPerClientTotals = data
    },
    async getPreviousJobsPerClientReports () {
      const {data} = await ReportService.get(this.previousJobsPerClientReport)
      this.previousJobsPerClientTotals = data
    },
  },
  mounted () {
    this.getReports()
  }
}
</script>
<style>
</style>
